var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import LruCache from '@hb/map-lru-cache';
import Logger from './logger';
import Storage from './storage';
var perf = typeof performance === 'object' &&
    performance &&
    typeof performance.now === 'function'
    ? performance
    : Date;
/**
 * ### DiskLruCache (es module)
 *
 * Taro 小程序
 *
 * ```js
 *  import { double } from '@hb/map-disk-lru-cache';
 *  import Taro from "@tarojs/taro";
 *
 *  const CACHE_KEY = '';
 *
 *  const diskLruCache = new DiskLRUCache(
 *    CACHE_KEY,
 *    {
 *      debug: true,
 *      max: 5,
 *      ttl: 60 * 60 * 1000,
 *      mpApi: Taro,
 *    }
 *  )
 * ```
 * @description DiskLruCache缓存策略算法，小程序版本实现
 */
var DiskLruCache = /** @class */ (function (_super) {
    __extends(DiskLruCache, _super);
    function DiskLruCache(namespace, options) {
        var _this = this;
        var mpApi = options.mpApi, debug = options.debug, mp = options.mp, limitSize = options.limitSize, limitCount = options.limitCount, lruOptions = __rest(options, ["mpApi", "debug", "mp", "limitSize", "limitCount"]);
        var logger = new Logger({ debug: debug, prefix: 'DiskLruCache(缓存策略)' });
        var storage = new Storage({ mp: mp, mpApi: mpApi, logger: logger });
        _this = _super.call(this, lruOptions) || this;
        _this.namespace = namespace;
        _this.mp = mp;
        _this.mpApi = mpApi;
        _this.dumpKey = namespace + ":dump";
        _this.limitSize = limitSize;
        _this.limitCount = limitCount || 0;
        _this.logger = logger;
        _this.storage = storage;
        _this.logger.info('初始化参数', options);
        // 初始化使用次数限制
        if (_this.limitCount > 0) {
            _this.initializeLimitCountTracking();
        }
        _this.initialization();
        return _this;
    }
    /**
     * 通过本地缓存初始化LRUCache
     * @description
     * - 存储`dump`时，没有保存value值，原因是小程序Storage存储限制
     * - value值的获取在`get`中进行处理，策略是，先读取LRUCache，若没有，再读取本地缓存
     * - 存储的时候一`key`对应一`value`，这样做也是为了提高存储上限，
     *   一次性读取多个key的值，初始化时会比较慢,所以放在`get`函数中处理`value`
     */
    DiskLruCache.prototype.initialization = function () {
        // 读取存储在本地的LruCache策略
        var dump = this.storage.getStorageSync(this.dumpKey);
        if (Array.isArray(dump)) {
            try {
                // 初始化LRU缓存
                this.load(dump);
                // 初始化之后再保存一下最新dump
                this.setDumpStorageSync();
            }
            catch (e) {
                this.clear();
                this.logger.error('本地缓存初始化失败', e);
            }
        }
    };
    DiskLruCache.prototype.initializeLimitCountTracking = function () {
        var _this = this;
        this.limitCounts = new Array(this.max).fill(0);
        this.currentCounts = new Array(this.max).fill(0);
        this.setItemLimitCount = function (index, limitCount, currentCount) {
            if (currentCount === void 0) { currentCount = 0; }
            if (_this.limitCounts && _this.currentCounts) {
                _this.currentCounts[index] = limitCount !== 0 ? currentCount : 0;
                _this.limitCounts[index] = limitCount;
            }
        };
        this.updateItemLimitCount = function (index) {
            if (_this.currentCounts && _this.limitCounts) {
                _this.currentCounts[index] =
                    _this.limitCounts[index] !== 0 ? _this.currentCounts[index] + 1 : 0;
            }
        };
        var _isStale = this.isStale.bind(this);
        this.isStale = function (index) {
            // @ts-ignore
            // const key = this.keyList[index];
            // @ts-ignore
            // const ttl = this.ttl > 0 ? this.ttls[index] : this.ttl;
            // @ts-ignore
            // const start = this.starts ? this.starts[index] : 0;
            var ttlStale = _isStale(index);
            var isLimitCountStale = false;
            if (_this.currentCounts && _this.limitCounts) {
                // 使用次数超限，则过期
                isLimitCountStale = _this.currentCounts[index] > _this.limitCounts[index];
            }
            _this.logger.info('this', _this);
            // 继承父类的过期判断
            return ttlStale || isLimitCountStale;
        };
    };
    // @ts-ignore
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    DiskLruCache.prototype.setItemLimitCount = function (index, limitCount, currentCount) {
        if (currentCount === void 0) { currentCount = 0; }
        // nothing
    };
    // @ts-ignore
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    DiskLruCache.prototype.updateItemLimitCount = function (index) {
        // nothing
    };
    // @ts-ignore
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    DiskLruCache.prototype.isStale = function (index) {
        return false;
    };
    /**
     * 重写`LRUCache`的`load`方法，将本地缓存中的数据加载到内存中
     * @description
     * 因为`LRUCache`的`set`,`clear`方法被重写过，所以需要调用父类方法，
     * 防止清空本地存储的数据
     * @param arr
     */
    DiskLruCache.prototype.load = function (arr) {
        // 使用父类clear() 只清空内存中的数据，不清空本地缓存
        _super.prototype.clear.call(this);
        for (var _i = 0, arr_1 = arr; _i < arr_1.length; _i++) {
            var _a = arr_1[_i], key = _a[0], entry = _a[1];
            if (entry.start) {
                // entry.start is a portable timestamp, but we may be using
                // node's performance.now(), so calculate the offset.
                // it's ok for this to be a bit slow, it's a rare operation.
                var age = Date.now() - entry.start;
                entry.start = perf.now() - age;
            }
            // 使用LRUCache的set方法，将本地缓存中的数据加载到内存中
            this.set(key, entry.value, __assign(__assign({}, (entry || {})), { isInitial: true }));
        }
        this.logger.info('本地缓存初始化成功', this.dump());
    };
    DiskLruCache.prototype.dump = function () {
        var _this = this;
        var arr = _super.prototype.dump.call(this);
        return arr.map(function (_a) {
            var key = _a[0], entry = _a[1];
            // @ts-ignore
            var index = _this.keyMap.get(key);
            var limitCount = _this.limitCounts ? _this.limitCounts[index] : undefined;
            var currentCount = _this.currentCounts
                ? _this.currentCounts[index]
                : undefined;
            return [key, __assign(__assign({}, entry), { limitCount: limitCount, currentCount: currentCount })];
        });
    };
    /**
     * 获取当前storage空间大小
     */
    DiskLruCache.prototype.getCurrentSize = function () {
        try {
            var info = this.storage.getStorageInfoSync();
            if (info) {
                return info.currentSize;
            }
        }
        catch (e) {
            this.logger.error('getCurrentSize', e);
        }
        return Infinity;
    };
    /**
     * 检查当前容量是否超限
     */
    DiskLruCache.prototype.limitSizeCheck = function () {
        if (this.limitSize) {
            var currentSize = this.getCurrentSize();
            if (currentSize > this.limitSize) {
                this.logger.info('容量超限不设置缓存', 'currentSize', currentSize, 'limitSize', this.limitSize);
                return true;
            }
        }
        return false;
    };
    /**
     * 将key加上namespace后再设置缓存，作用数据隔离
     * @param key
     */
    DiskLruCache.prototype.getKey = function (key) {
        // 具有namespace的key，直接返回
        if (key.startsWith(this.namespace))
            return key;
        // 没有namespace的key，加上namespace后返回
        return this.namespace + ":" + key;
    };
    /**
     * 根据key 获取缓存index
     * @param key
     */
    DiskLruCache.prototype.getIndex = function (key) {
        var _key = this.getKey(key);
        // LRUCache 存在该属性，但是未声明
        // @ts-ignore
        return this.keyMap.get(_key);
    };
    /**
     * 当前key过期信息
     * @param key
     */
    DiskLruCache.prototype.getInfo = function (key) {
        var dump = this.dump();
        var dumpMap = dump.reduce(function (acc, cur) {
            var _key = cur[0], value = cur[1];
            acc[_key] = value;
            return acc;
        }, {});
        this.logger.info('getInfo', this.getKey(key), dumpMap, dumpMap[this.getKey(key)]);
        return dumpMap[this.getKey(key)];
    };
    /**
     * 更新缓存value
     * @param key
     * @param val
     */
    DiskLruCache.prototype.setValList = function (key, val) {
        var index = this.getIndex(key);
        if (index) {
            // LRUCache 存在该属性，但是未声明
            // @ts-ignore
            this.valList[index] = val;
        }
    };
    /**
     * 读取LRU缓存策略，并存在本地缓存中，后续用于恢复LRUCache
     * @description
     * - 不保存value值，原因是小程序Storage存储限制，value值太大会导致存储失败
     * - 支付宝：单key，上限200KB
     * - 微信：单key，上限1MB
     * - 在`get`、`set`、`del`中调用，同步缓存策略至本地
     */
    DiskLruCache.prototype.setDumpStorageSync = function () {
        var isSuccess = false;
        try {
            var dump = this.dump();
            var _dump = dump.map(function (_a) {
                var key = _a[0], value = _a[1];
                return [
                    key,
                    __assign(__assign({}, (value || {})), { value: undefined }),
                ];
            });
            this.storage.setStorageSync(this.dumpKey, _dump);
            isSuccess = true;
        }
        catch (e) {
            // 同步策略失败则清空缓存
            this.clear();
            this.logger.error('setDumpStorageSync', e);
        }
        return isSuccess;
    };
    /**
     * 设置缓存
     * @param key
     * @param value
     * @param options
     */
    DiskLruCache.prototype.set = function (key, value, options) {
        var _a = options || {}, _b = _a.isInitial, isInitial = _b === void 0 ? false : _b, _c = _a.limitCount, limitCount = _c === void 0 ? this.limitCount : _c, _d = _a.noUpdateLimitCount, noUpdateLimitCount = _d === void 0 ? this.noUpdateLimitCount : _d, currentCount = _a.currentCount, opts = __rest(_a, ["isInitial", "limitCount", "noUpdateLimitCount", "currentCount"]);
        var _key = this.getKey(key);
        var firstNoGetIndex = false;
        var _noUpdateLimitCount = noUpdateLimitCount;
        try {
            // 容量超限
            if (this.limitSizeCheck()) {
                // 初始化时，将超限的数据删除
                if (isInitial) {
                    try {
                        if (_key)
                            this.storage.removeStorageSync(_key);
                    }
                    catch (e) {
                        this.logger.error('初始化，容量超限，删除', _key, e);
                    }
                }
                return this;
            }
            // @ts-ignore
            var index = this.size === 0 ? undefined : this.keyMap.get(_key);
            if (index === undefined) {
                // 没有该key的标记
                firstNoGetIndex = true;
                // 创新新项，必需初始化
                _noUpdateLimitCount = false;
            }
            // 这一步必定会产出一个新的index索引
            _super.prototype.set.call(this, _key, value, opts);
            if (limitCount !== 0 && this.limitCount === 0 && !this.limitCounts) {
                this.initializeLimitCountTracking();
            }
            if (!_noUpdateLimitCount) {
                // index === undefined，说明是新增项，需对limitCount进行初始化
                // `super.set`会生成新的索引，this.tail === index
                // index !== undefined，说明是更新项，需对limitCount进行更新
                // @ts-ignore
                var _index = firstNoGetIndex ? this.tail : index;
                this.setItemLimitCount(_index, limitCount, currentCount);
            }
            // 初始化时不用重复往本地缓存中写入
            if (!isInitial) {
                var isSuccess = this.setDumpStorageSync();
                if (isSuccess) {
                    this.storage.setStorageSync(_key, value);
                    this.logger.info('set', _key, value);
                }
            }
        }
        catch (e) {
            this.logger.error('set', e);
        }
        return this;
    };
    /**
     * 获取缓存数据
     * 先读LRUCache内存缓存，再尝试读本地缓存
     * @param key
     * @param options
     */
    DiskLruCache.prototype.get = function (key, options) {
        try {
            // 在内存中读取
            var _key = this.getKey(key);
            // @ts-ignore
            var index = this.keyMap.get(_key);
            // 更新次数
            if (index !== undefined) {
                this.updateItemLimitCount(index);
            }
            var result = _super.prototype.get.call(this, _key, options);
            // 更新策略
            var isSuccess = this.setDumpStorageSync();
            if (!isSuccess)
                return;
            // 内存中存在则直接返回
            if (result) {
                this.logger.info('get', _key, result);
                return result;
            }
            // 先检查该key是否存在LRUCache中，如果存在，则读取本地缓存
            if (this.has(_key)) {
                // 尝试在本地缓存中读取
                var val = this.storage.getStorageSync(_key);
                // 如果本地缓存中存在，则更新内存缓存
                this.setValList(_key, val);
                this.logger.info('storage get', _key, val);
                return val;
            }
        }
        catch (e) {
            this.logger.error('get', e);
        }
        return;
    };
    /**
     * 驱逐最近最少使用的内部 ID，返回其 ID
     * @description 驱逐并删除本地缓存
     * @param free
     */
    DiskLruCache.prototype.evict = function (free) {
        // @ts-ignore
        var head = this.head;
        // @ts-ignore
        var key = this.keyList[head];
        try {
            if (key)
                this.storage.removeStorageSync(key);
            this.logger.info('evict(陈旧)', key);
        }
        catch (e) {
            this.logger.error('evict(陈旧)', e);
        }
        // @ts-ignore
        var r = _super.prototype.evict.call(this, free);
        this.setDumpStorageSync();
        return r;
    };
    /**
     * 删除缓存
     * @param key
     */
    DiskLruCache.prototype.delete = function (key) {
        try {
            var _key = this.getKey(key);
            var deleted = _super.prototype.delete.call(this, _key);
            if (deleted) {
                // 更新策略
                deleted = this.setDumpStorageSync();
                if (deleted)
                    this.storage.removeStorageSync(_key);
            }
            this.logger.info('delete', key, deleted);
            return deleted;
        }
        catch (e) {
            this.logger.error('delete', e);
            return false;
        }
    };
    /**
     * 清空缓存
     */
    DiskLruCache.prototype.clear = function () {
        var _a, _b;
        var isClear = false;
        try {
            // 清空命名空间中的所有数据
            var isSuccess = this.storage.clearStorageSync(this.namespace);
            // 清空次数限制
            if (this.limitCount) {
                (_a = this.limitCounts) === null || _a === void 0 ? void 0 : _a.fill(0);
                (_b = this.currentCounts) === null || _b === void 0 ? void 0 : _b.fill(0);
            }
            // 清空内存缓存
            _super.prototype.clear.call(this);
            isClear = isSuccess;
        }
        catch (e) {
            this.logger.error('clear', e);
        }
        return isClear;
    };
    return DiskLruCache;
}(LruCache));
export default DiskLruCache;
//# sourceMappingURL=data:application/json;base64,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